import { Component, OnInit } from "@angular/core";
import { AppService } from "src/app/core/app/app.service";
import { Router } from "@angular/router";
import { Subscription, Observable } from "rxjs";
import { OrderFactoryPeriodSummary } from "src/app/core/order/analytics/summaries/summary.abstract";
@Component({
  selector: "ll-period-totals-card",
  templateUrl: "./period-totals-card.component.html",
  styleUrls: ["./period-totals-card.component.scss"]
})
export class PeriodTotalsCardComponent implements OnInit {
  public loading: boolean;
  public subscription: Subscription;
  constructor(private app: AppService, private router: Router) {
    this.loading = true;
  }

  ngOnInit() {}

  get data$(): Observable<OrderFactoryPeriodSummary> {
    return this.app.state.periodTotalData$;
  }

  get isAdmin(): boolean {
    return !this.router.url.includes("venue");
  }

  mask(num: number): string {
    if (num > 100000) return "$" + (num / 1000).toFixed(0) + "K";
    else if (num > 1000) return "$" + (num / 1000).toFixed(1) + "K";
    return "$" + num.toFixed(2);
  }
}
